export enum RoleAccessEnum {
	view = 'view',
	create = 'create',
	update = 'update',
	delete = 'delete',
	filter = 'filter',
	upload = 'upload',
	download = 'download',
	archive = 'archive',
}
